module.exports = __webpack_public_path__ + "8cd04f99f90071304f1b7f9e859f7101.pdf";